import {
  Box,
  Button,
  Checkbox,
  CircularProgress,
  FormControl,
  FormControlLabel,
  Grid,
  InputLabel,
  Link,
  MenuItem,
  OutlinedInput,
  Paper,
  Select,
  SelectChangeEvent,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
  Typography,
} from '@mui/material'
import ViewListIcon from '@mui/icons-material/ViewList'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { inject } from 'mobx-react'
import * as React from 'react'
import { pagedList } from 'src/viewModels/pagedList'
import { QuoteSummaryResult } from 'src/viewModels/QuoteSummaryResult'
import ResponsiveAppBar from '../common/ResponsiveAppBar'
import { IStores } from '../Stores'
import { QuoteStatus } from '../utils/QuoteStatus'
import BundleClaimsModal from './QuoteBills/BundleClaimsModal'
import { formatCurrency } from '../utils/Formatter'
import InvoiceStatusIcon from './InvoiceStatusIcon'
import ReactPaginate from 'react-paginate'
import { QuoteSearchRequest } from 'src/viewModels/QuoteSearchRequest'
import {
  generateCostSavings,
  GetQuoteTotalsSummary,
  searchQuotes,
} from 'src/services/QuoteService'
import Moment from 'moment'
import ESMenu from 'src/common/ESMenu'
import { CommentOutline } from 'mdi-material-ui'
import { Helmet } from 'react-helmet'
import {
  AddShoppingCart,
  CheckBox,
  CheckBoxOutlineBlank,
  InfoOutlined,
  ReceiptOutlined,
} from '@mui/icons-material'
import InvoiceLogModal from './InvoiceLogModal'
import EOCStatus, { EOCStatusOptions } from 'src/utils/EOCStatus'
import QuoteLogModal from './QuoteLogModal'
import { IQuoteDTO } from 'src/viewModels/quotes/QuoteDTO'
import { QuoteTotalsSummary } from 'src/viewModels/quotes/QuoteTotalsSummary'
import { QuoteType } from 'src/utils/QuoteType'
import SortedTableCell, { sortedTableHeaderSx } from 'src/workflow/SortedTableCell'
// tslint:disable-next-line: no-var-requires
const CurrencyFormat: any = require('react-currency-format')

interface IQuoteListProps {
  buildQuoteMenuItems?: (quote: QuoteSummaryResult) => any[]
  openBillsDialog?: (quoteId: string) => Promise<void>
  invoiceLogModalIsOpen?: boolean
  selectedQuoteId?: string
  selectedInvoiceId?: string
  closeInvoiceLogModal?: () => void
  openInvoiceLogModal?: (request: QuoteSummaryResult) => void
  startRecon?: boolean
  restartQuote?: boolean
  setParentRefreshWithBundle?: (setRefresh: boolean) => void
  setReloadFunction?: (searchFunc: () => void) => void
  setQuoteRequest?: (request: QuoteSearchRequest) => void
  storedRequest?: QuoteSearchRequest
  selectedPatientHeader?: string
  selectedQuote?: IQuoteDTO
  adjusterModalIsOpen?: boolean
}

class QuoteList extends React.Component<IQuoteListProps> {
  public quoteStatus = [
    { key: QuoteStatus.Dismissed.toString(), text: 'Dismissed' },
    { key: QuoteStatus.DismissedByConsumer.toString(), text: 'Dismissed By Consumer' },
    { key: QuoteStatus.Draft.toString(), text: 'Draft' },
    { key: QuoteStatus.Imported.toString(), text: 'Imported' },
    { key: QuoteStatus.NeedsQuote.toString(), text: 'Needs Quote' },
    { key: QuoteStatus.NeedsRecon.toString(), text: 'Needs Reconciliation' },
    {
      key: QuoteStatus.PendingCareCoordinator.toString(),
      text: 'Pending Care Coordinator',
    },
    { key: QuoteStatus.PendingContract.toString(), text: 'Pending Contract' },
    { key: QuoteStatus.PendingFinance.toString(), text: 'Pending Finance' },
    { key: QuoteStatus.Quoted.toString(), text: 'Quoted' },
    { key: QuoteStatus.Reconciled.toString(), text: 'Reconciled' },
  ]

  public quoteType = [
    { key: QuoteType.Injection.toString(), text: 'Injection' },
    { key: QuoteType.NonSurgical.toString(), text: 'Non-Surgical' },
    { key: QuoteType.PostInjection.toString(), text: 'Post-Injection' },
    { key: QuoteType.PostSurgical.toString(), text: 'Post-Surgical' },
    { key: QuoteType.Surgical.toString(), text: 'Surgical' },
  ]

  public state = {
    gridData: new pagedList().items as QuoteSummaryResult[],
    page: 1,
    pageCount: 0,
    firstRecordIndex: 0,
    lastRecordIndex: 0,
    totalItems: 0,
    pageSize: 25,
    searchPatientLastName: this.props.storedRequest?.patientLastName ?? '',
    searchPatientFirstName: this.props.storedRequest?.patientFirstName ?? '',
    searchEOCNum: this.props.storedRequest?.eocNumber ?? '',
    searchCptCode: this.props.storedRequest?.cptCode ?? '',
    searchProviderGroup: this.props.storedRequest?.providerGroup ?? '',
    searchInsuranceCompany: this.props.storedRequest?.insuranceCompany ?? '',
    searchPrimaryAdjuster: this.props.storedRequest?.primaryAdjuster ?? '',
    searchStartDateFrom: this.props.storedRequest?.startDateFrom ?? '',
    searchStartDateTo: this.props.storedRequest?.startDateTo ?? '',
    searchQuoteStatus: new Map<string, string>(),
    searchQuoteType: new Map<string, string>(),
    searchEOCStatus: this.props.storedRequest?.eocStatus ?? '',
    searchEmployer: this.props.storedRequest?.employer ?? '',
    searchInvoiceStatus: this.props.storedRequest?.invoiced
      ? 'Invoiced'
      : this.props.storedRequest?.notInvoiced
        ? 'NotInvoiced'
        : '',
    searchConsumerQuotesOnly: false,
    selectedEocNumber: '',
    gridLoading: false,
    hasMMI: false,
    disableLinks: true,
    pdfLoading: false,
    selectedInvoiceId: '',
    selectedGroupInfo: '',
    quoteTotals: new QuoteTotalsSummary(),
    sortColumn: '',
    sortOrder: 'asc',
  }

  public componentDidMount() {
    if (this.props.storedRequest?.quoteStatuses != undefined) {
      this.props.storedRequest?.quoteStatuses.forEach((status) => {
        this.state.searchQuoteStatus.set(
          status.toString(),
          this.quoteStatus.find((x) => x.key == status.toString())!.text
        )
      })
    }

    if (this.props.storedRequest?.quoteTypes != undefined) {
      this.props.storedRequest?.quoteTypes.forEach((type) => {
        this.state.searchQuoteType.set(
          type.toString(),
          this.quoteType.find((x) => x.key == type.toString())!.text
        )
      })
    }

    this.setState({
      searchQuoteStatus: this.state.searchQuoteStatus,
      searchQuoteType: this.state.searchQuoteType,
    })
    this.props.setParentRefreshWithBundle!(false)
    this.props.setReloadFunction!(this.getQuoteData)
  }

  private isGridDataEmpty = () => {
    return this.state.totalItems == 0
  }

  private paginationInfo = () => {
    if (!this.isGridDataEmpty()) {
      return (
        <div style={{ paddingBottom: '20px' }} className="pagination">
          <Typography variant="caption" gutterBottom>
            Showing {this.state.firstRecordIndex} to {this.state.lastRecordIndex} of{' '}
            {this.state.totalItems} entries
          </Typography>
        </div>
      )
    } else {
      return <></>
    }
  }

  private search = (event: any) => {
    this.setState({ page: 1 }, () => this.getQuoteData(true))
    event.preventDefault()
  }

  public sort = (columnName: string) => {
    const isNewColumn = this.state.sortColumn !== columnName

    this.setState(
      {
        sortColumn: columnName,
        sortOrder: isNewColumn ? 'asc' : this.state.sortOrder === 'asc' ? 'desc' : 'asc',
        gridLoading: true,
        page: 1,
      },
      () => {
        this.getQuoteData().catch(() => {})
      }
    )
  }

  private renderSortedHeaderIfNotNewlyAdded = (
    columnName: string,
    propertyName: string,
    align?: any,
    style?: React.CSSProperties
  ) => {
    const hasData = !!this.state.gridData && this.state.gridData.length > 0
    return (
      <SortedTableCell
        columnName={columnName}
        propertyName={propertyName}
        align={align}
        style={style}
        order={this.state.sortOrder}
        orderBy={this.state.sortColumn}
        onClick={this.sort}
        sortable={hasData}
        reserveSortIconSpace
      />
    )
  }

  private isConsumerQuote = (quote: QuoteSummaryResult) => {
    return quote.isConsumer === true
  }

  private renderCoordinationBadge = (coordinationStatus?: string) => {
    const label = coordinationStatus?.trim().replace(/\s*only$/i, '')
    if (!label) {
      return null
    }
    return (
      <Box
        component="span"
        sx={{
          flexShrink: 0,
          bgcolor: 'secondary.main',
          color: 'secondary.contrastText',
          borderRadius: '8px',
          fontSize: '10px',
          fontWeight: 600,
          lineHeight: '16px',
          height: '16px',
          minWidth: '16px',
          px: '4px',
          textAlign: 'center',
        }}
      >
        {label}
      </Box>
    )
  }

  private mapGridData = () => {
    if (this.isGridDataEmpty() || !this.state.gridData) {
      return (
        <TableRow key={1}>
          <TableCell colSpan={17} align="center">
            No records found
          </TableCell>
        </TableRow>
      )
    } else {
      return this.state.gridData.map((quote, index) => (
        <TableRow key={index} className="gridPadding">
          <TableCell
            style={{
              paddingRight: '4px',
              paddingLeft: '4px',
              whiteSpace: 'nowrap',
            }}
          >
            {this.isConsumerQuote(quote) && (
              <Tooltip title="Consumer Quote">
                <span
                  style={{
                    fontSize: 'large',
                    verticalAlign: 'middle',
                    display: 'inline-flex',
                    alignItems: 'center',
                    cursor: 'default',
                  }}
                >
                  🦈
                </span>
              </Tooltip>
            )}
          </TableCell>
          <TableCell
            style={{ whiteSpace: 'nowrap', paddingRight: '2px', paddingLeft: '4px' }}
          >
            {quote.eocNumber}&nbsp;&nbsp;
          </TableCell>
          <TableCell
            style={{
              paddingRight: '4px',
              paddingLeft: '2px',
              whiteSpace: 'nowrap',
              maxWidth: '100px',
            }}
            align="right"
          >
            {quote.groupNumber}
          </TableCell>
          <TableCell
            style={{ paddingRight: '4px', paddingLeft: '4px', whiteSpace: 'nowrap' }}
          >
            {quote.quoteType}
          </TableCell>
          <TableCell
            style={{ whiteSpace: 'nowrap', paddingRight: '4px', paddingLeft: '4px' }}
          >
            {quote.quoteStatus}&nbsp;&nbsp;
            {quote.latestStatusComment ? (
              <Tooltip title={quote.latestStatusComment}>
                <span
                  style={{
                    verticalAlign: 'middle',
                    display: 'inline-flex',
                    alignItems: 'center',
                  }}
                >
                  <CommentOutline fontSize="small" />
                </span>
              </Tooltip>
            ) : (
              <></>
            )}
          </TableCell>
          <TableCell
            style={{ paddingRight: '4px', paddingLeft: '4px', whiteSpace: 'nowrap' }}
          >
            {quote.patientName}
          </TableCell>
          <Tooltip title={quote.insuranceCompanyName || ''}>
            <TableCell
              style={{
                paddingRight: '4px',
                paddingLeft: '4px',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                maxWidth: '150px',
                cursor: 'default',
              }}
            >
              {quote.insuranceCompanyName}
            </TableCell>
          </Tooltip>
          <TableCell
            style={{ paddingRight: '4px', paddingLeft: '4px', whiteSpace: 'nowrap' }}
            align="right"
          >
            {quote.startDate &&
            new Date(quote.startDate!).valueOf() >
              new Date('1900-01-17T03:24:00').valueOf()
              ? Moment(quote.startDate).format('MM/DD/YYYY')
              : ''}
          </TableCell>
          <TableCell
            style={{
              paddingRight: '4px',
              paddingLeft: '4px',
              whiteSpace: 'nowrap',
              maxWidth: '50px',
            }}
          ></TableCell>
          <TableCell
            align="right"
            style={{ paddingRight: '4px', paddingLeft: '4px', whiteSpace: 'nowrap' }}
          >
            {quote.bundleDurationDays}
          </TableCell>
          <Tooltip title={quote.inbox || ''}>
            <TableCell
              style={{
                paddingRight: '4px',
                paddingLeft: '4px',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                maxWidth: '150px',
                cursor: 'default',
              }}
            >
              {quote.inbox}
            </TableCell>
          </Tooltip>
          <Tooltip
            title={[quote.eocStatus, quote.coordinationStatus]
              .filter(Boolean)
              .join(' - ')}
          >
            <TableCell
              style={{
                paddingRight: '4px',
                paddingLeft: '4px',
                whiteSpace: 'nowrap',
                maxWidth: '110px',
                cursor: 'default',
              }}
            >
              <span style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                <span style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>
                  {quote.eocStatus}
                </span>
                {this.renderCoordinationBadge(quote.coordinationStatus)}
              </span>
            </TableCell>
          </Tooltip>
          <TableCell
            align="right"
            style={{ paddingRight: '4px', paddingLeft: '4px', whiteSpace: 'nowrap' }}
          >
            {quote.amount != undefined ? formatCurrency(quote.amount.toString()) : ''}
          </TableCell>
          <TableCell
            align="right"
            style={{ paddingRight: '4px', paddingLeft: '4px', whiteSpace: 'nowrap' }}
          >
            {quote.reconciledAmount != undefined
              ? formatCurrency(quote.reconciledAmount.toString())
              : ''}
          </TableCell>
          {quote.nonPTBundledClaimCount > 0 ? (
            <TableCell
              style={{ whiteSpace: 'nowrap', paddingRight: '4px', paddingLeft: '4px' }}
              align="right"
            >
              {quote.nonPTOverallClaimPercentageReconciled.toString() + '%'}
              &nbsp;&nbsp;
              <Tooltip
                title={`Based on ${quote.nonPTBundledClaimCount.toString()} bundled non-PT claim${
                  quote.nonPTBundledClaimCount > 1 ? 's' : ''
                }`}
              >
                <InfoOutlined fontSize="small" style={{ verticalAlign: 'middle' }} />
              </Tooltip>
            </TableCell>
          ) : (
            <TableCell
              style={{ paddingRight: '4px', paddingLeft: '4px', whiteSpace: 'nowrap' }}
            ></TableCell>
          )}
          <TableCell
            align="right"
            style={{ whiteSpace: 'nowrap', paddingRight: '4px', paddingLeft: '4px' }}
          >
            <InvoiceStatusIcon
              isInvoiced={!!quote.invoiceId}
              quoteStatus={quote.quoteStatus}
              invoicedAmount={quote.invoicedAmount}
              balanceDue={quote.balanceDue}
              initialInvoicePrintDate={quote.initialInvoicePrintDate}
            />
            &nbsp;&nbsp;
            {quote.invoiceId != undefined ? (
              <Tooltip title="Show Invoice Log">
                <ReceiptOutlined
                  style={{ cursor: 'pointer', verticalAlign: 'middle' }}
                  fontSize="small"
                  onClick={() => this.props.openInvoiceLogModal!(quote)}
                />
              </Tooltip>
            ) : (
              <ReceiptOutlined
                aria-hidden="true"
                fontSize="small"
                style={{ visibility: 'hidden', verticalAlign: 'middle' }}
              />
            )}
          </TableCell>
          <TableCell
            style={{ paddingRight: '4px', paddingLeft: '4px', whiteSpace: 'nowrap' }}
          >
            <Tooltip
              title={
                quote.eocUnbundledClaims
                  ? 'Bundle Claims - There are claims that are not in any bundle'
                  : 'Bundle Claims'
              }
            >
              <AddShoppingCart
                fontSize="small"
                sx={{
                  cursor: 'pointer',
                  verticalAlign: 'middle',
                  marginRight: 1,
                  color: quote.eocUnbundledClaims ? 'red' : 'text.primary',
                }}
                onClick={() => this.props.openBillsDialog!(quote.quoteId)}
              />
            </Tooltip>
            {this.renderContextMenu(quote, index)}
          </TableCell>
        </TableRow>
      ))
    }
  }

  private getQuoteData = async (
    setSavedSearch: boolean = false,
    forPageChange: boolean = false
  ) => {
    this.setState({ gridLoading: true })
    const { page, pageSize, sortColumn, sortOrder } = this.state
    const requestData = new QuoteSearchRequest()
    const selectStatuses = Array.from(this.state.searchQuoteStatus.keys())
    const selectedTypes = Array.from(this.state.searchQuoteType.keys())
    requestData.page = page
    requestData.pageSize = pageSize
    requestData.patientFirstName = this.state.searchPatientFirstName
    requestData.patientLastName = this.state.searchPatientLastName
    requestData.cptCode = this.state.searchCptCode
    requestData.providerGroup = this.state.searchProviderGroup
    requestData.quoteStatuses = selectStatuses.map(Number)
    requestData.quoteTypes = selectedTypes.map(Number)
    requestData.employer = this.state.searchEmployer
    requestData.startDateFrom = this.state.searchStartDateFrom
    requestData.startDateTo = this.state.searchStartDateTo
    requestData.eocNumber = this.state.searchEOCNum
    requestData.insuranceCompany = this.state.searchInsuranceCompany
    requestData.primaryAdjuster = this.state.searchPrimaryAdjuster
    requestData.eocStatus = this.state.searchEOCStatus
    requestData.invoiced = this.state.searchInvoiceStatus === 'Invoiced'
    requestData.notInvoiced = this.state.searchInvoiceStatus === 'NotInvoiced'
    requestData.isConsumer = this.state.searchConsumerQuotesOnly
    requestData.sorting = sortColumn
      ? { column: sortColumn, order: sortOrder }
      : undefined
    await searchQuotes(requestData)
      .then(async (response: any) => {
        this.setState({
          gridData: response.items,
          pageCount: response.totalPages,
          totalItems: response.totalItems,
        })

        if (forPageChange) {
          this.setState({
            gridLoading: false,
          })
          if (response.totalItems > 0) {
            this.setPaginationOffsetData()
          }
        } else {
          await GetQuoteTotalsSummary(requestData)
            .then((totals: any) => {
              this.setState({
                quoteTotals: totals,
                gridLoading: false,
              })

              if (
                response.totalItems > 0 &&
                this.state.searchEOCStatus == EOCStatus.CaseClosed
              ) {
                this.setState({ hasMMI: true, disableLinks: false })
              } else {
                this.setState({ disableLinks: true })
              }

              if (response.totalItems > 0) {
                this.setPaginationOffsetData()
              }

              if (setSavedSearch) {
                this.props.setQuoteRequest!(requestData)
              }
            })
            .catch(() => {
              this.setState({ gridLoading: false })
            })
        }
      })
      .catch(() => {
        this.setState({ gridLoading: false })
      })
  }

  private getPdf = async (bundled: boolean) => {
    this.setState({ pdfLoading: true })
    const requestData = new QuoteSearchRequest()
    const selectStatuses = Array.from(this.state.searchQuoteStatus.keys())
    const selectedTypes = Array.from(this.state.searchQuoteType.keys())
    requestData.patientFirstName = this.state.searchPatientFirstName
    requestData.patientLastName = this.state.searchPatientLastName
    requestData.cptCode = this.state.searchCptCode
    requestData.providerGroup = this.state.searchProviderGroup
    requestData.quoteStatuses = selectStatuses.map(Number)
    requestData.quoteTypes = selectedTypes.map(Number)
    requestData.employer = this.state.searchEmployer
    requestData.startDateFrom = this.state.searchStartDateFrom
    requestData.startDateTo = this.state.searchStartDateTo
    requestData.eocNumber = this.state.searchEOCNum
    requestData.insuranceCompany = this.state.searchInsuranceCompany
    requestData.primaryAdjuster = this.state.searchPrimaryAdjuster
    requestData.eocStatus = this.state.searchEOCStatus

    await generateCostSavings(requestData, bundled).then(() => {
      this.setState({ pdfLoading: false })
    })
  }

  private setPaginationOffsetData = () => {
    const { page, totalItems, pageSize } = this.state
    const firstRecordIndex = (page - 1) * pageSize + 1
    const lastRecordIndex = page * pageSize < totalItems ? page * pageSize : totalItems
    this.setState({
      firstRecordIndex: firstRecordIndex,
      lastRecordIndex: lastRecordIndex,
      totalItems: totalItems,
    })
  }

  private handlePageChange = (event: any) => {
    const page = event.selected
    this.setState({ page: page + 1 }, () => this.getQuoteData(undefined, true))
  }

  private clearSearch = () => {
    this.setState(
      {
        page: 1,
        searchPatientLastName: '',
        searchPatientFirstName: '',
        searchCptCode: '',
        searchProviderGroup: '',
        searchEOCNum: '',
        searchInsuranceCompany: '',
        searchPrimaryAdjuster: '',
        searchStartDateFrom: '',
        searchStartDateTo: '',
        searchQuoteStatus: new Map<string, string>(),
        searchQuoteType: new Map<string, string>(),
        searchEOCStatus: '',
        searchEmployer: '',
        hasMMI: false,
        searchInvoiceStatus: '',
        searchConsumerQuotesOnly: false,
      },
      () => {
        this.setState({ gridData: undefined, pageCount: 0, totalItems: 0 })
        this.props.setQuoteRequest!(new QuoteSearchRequest())
      }
    )
  }

  private handlePatientFirstNameChange = (event: any) => {
    this.setState({ searchPatientFirstName: event.target.value })
  }

  private handlePatientLastNameChange = (event: any) => {
    this.setState({ searchPatientLastName: event.target.value })
  }

  private handleEOCNumChange = (event: any) => {
    this.setState({ searchEOCNum: event.target.value })
  }

  private handleProviderGroupChange = (event: any) => {
    this.setState({ searchProviderGroup: event.target.value })
  }

  private handleCptCodeChange = (event: any) => {
    this.setState({ searchCptCode: event.target.value })
  }

  private handleInsuranceCompanyChange = (event: any) => {
    this.setState({ searchInsuranceCompany: event.target.value })
  }

  private handlePrimaryAdjusterChange = (event: any) => {
    this.setState({ searchPrimaryAdjuster: event.target.value })
  }

  private handleQuoteStatusChange = (event: SelectChangeEvent<string[]>) => {
    const selectedValues = event.target.value as string[]
    const newMap = new Map<string, string>()

    selectedValues.forEach((value) => {
      const item = this.quoteStatus.find((s) => s.key === value)
      if (item) {
        newMap.set(value, item.text || '')
      }
    })

    this.setState({ searchQuoteStatus: newMap })
  }

  private handleQuoteTypeChange = (event: SelectChangeEvent<string[]>) => {
    const selectedValues = event.target.value as string[]
    const newMap = new Map<string, string>()

    selectedValues.forEach((value) => {
      const item = this.quoteType.find((s) => s.key === value)
      if (item) {
        newMap.set(value, item.text || '')
      }
    })

    this.setState({ searchQuoteType: newMap })
  }

  private handleSurgeryStartDateChange = (date: any) => {
    this.setState({ searchStartDateFrom: date ? Moment(date).format('YYYY-MM-DD') : '' })
  }

  private handleSurgeryEndDateChange = (date: any) => {
    this.setState({ searchStartDateTo: date ? Moment(date).format('YYYY-MM-DD') : '' })
  }

  private handleEmployerChange = (event: any) => {
    this.setState({ searchEmployer: event.target.value })
  }

  private handleEOCStatusChange = (event: any) => {
    this.setState({ searchEOCStatus: event.target.value })
  }

  private handleInvoiceStatusChange = (event: any) => {
    this.setState({ searchInvoiceStatus: event.target.value })
  }

  private handleConsumerQuotesOnlyChange = () => {
    this.setState({ searchConsumerQuotesOnly: !this.state.searchConsumerQuotesOnly })
  }

  private renderContextMenu = (quote: QuoteSummaryResult, index: number) => {
    let options = this.props.buildQuoteMenuItems!(quote)

    return (
      <ESMenu
        data={quote}
        menuItems={options}
        rowIndex={index}
        menuAriaLabel={`$quote-${index}-menu`}
      />
    )
  }

  public render() {
    const disableLink = this.state.disableLinks
    const MenuProps = {
      getContentAnchorEl: null,
      PaperProps: {
        style: {
          maxHeight: 400,
        },
      },
    }

    return (
      <>
        <Helmet>
          <title>Quotes</title>
        </Helmet>
        <ResponsiveAppBar title={'Quotes'} pageIcon={<ViewListIcon />} />
        <Paper style={{ margin: '15px', height: '100%', paddingBottom: '20px' }}>
          <Grid container style={{ width: '100%', paddingBottom: '20px' }}>
            <BundleClaimsModal />
            {this.props.selectedQuoteId && <QuoteLogModal />}
            {this.props.selectedQuoteId && this.props.selectedInvoiceId ? (
              <InvoiceLogModal
                headerText={this.props.selectedPatientHeader!}
                quoteId={this.props.selectedQuoteId}
                invoiceId={this.props.selectedInvoiceId}
                isOpen={this.props.invoiceLogModalIsOpen}
                closeModal={this.props.closeInvoiceLogModal!}
              />
            ) : (
              <></>
            )}
            {(this.state.gridLoading || this.state.pdfLoading) && (
              <div
                style={{
                  position: 'fixed',
                  display: 'flex',
                  width: '100%',
                  height: '100%',
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  backgroundColor: 'rgba(0, 0, 0, 0.5)',
                  cursor: 'pointer',
                  alignItems: 'center',
                  justifyContent: 'center',
                  zIndex: '2',
                }}
              >
                <CircularProgress size={100} />
              </div>
            )}
            <form onSubmit={this.search}>
              <Grid
                container
                item
                style={{ margin: '10px 0px', paddingLeft: '30px', width: '100%' }}
                xs={12}
              >
                <Typography
                  color="primary"
                  component="h6"
                  variant="h6"
                  gutterBottom
                  style={{ paddingBottom: '10px' }}
                >
                  SEARCH CRITERIA
                </Typography>
                <Grid container direction="row" spacing={2} style={{ width: '100%' }}>
                  <Grid item xs={2}>
                    <FormControl fullWidth>
                      <TextField
                        value={this.state.searchPatientFirstName}
                        onChange={this.handlePatientFirstNameChange}
                        label="Patient First Name"
                        name="patientFirst"
                        InputLabelProps={{ shrink: true }}
                        variant="outlined"
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={2}>
                    <FormControl fullWidth>
                      <TextField
                        value={this.state.searchPatientLastName}
                        onChange={this.handlePatientLastNameChange}
                        label="Patient Last Name"
                        name="patientLast"
                        InputLabelProps={{ shrink: true }}
                        variant="outlined"
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={4}>
                    <FormControl fullWidth>
                      <TextField
                        value={this.state.searchProviderGroup}
                        onChange={this.handleProviderGroupChange}
                        label="Provider Group"
                        name="providerGroup"
                        InputLabelProps={{ shrink: true }}
                        variant="outlined"
                      />
                    </FormControl>
                  </Grid>
                  <Grid item container xs={4} direction="row">
                    <Grid item xs={4}>
                      <DatePicker
                        label="Start Date From"
                        value={
                          this.state.searchStartDateFrom
                            ? Moment(this.state.searchStartDateFrom)
                            : null
                        }
                        onChange={this.handleSurgeryStartDateChange}
                        slotProps={{
                          textField: {
                            fullWidth: true,
                            variant: 'outlined',
                            InputLabelProps: { shrink: true },
                          },
                          openPickerIcon: {
                            fontSize: 'small',
                          },
                        }}
                      />
                    </Grid>
                    <Grid item style={{ margin: '0px 10px' }}>
                      <strong> - </strong>
                    </Grid>
                    <Grid item xs={4}>
                      <DatePicker
                        label="Start Date To"
                        value={
                          this.state.searchStartDateTo
                            ? Moment(this.state.searchStartDateTo)
                            : null
                        }
                        onChange={this.handleSurgeryEndDateChange}
                        slotProps={{
                          textField: {
                            fullWidth: true,
                            variant: 'outlined',
                            InputLabelProps: { shrink: true },
                          },
                          openPickerIcon: {
                            fontSize: 'small',
                          },
                        }}
                      />
                    </Grid>
                  </Grid>
                  <Grid item xs={2}>
                    <FormControl fullWidth>
                      <TextField
                        value={this.state.searchEOCNum}
                        onChange={this.handleEOCNumChange}
                        label="EOC/Legacy"
                        name="eocNum"
                        InputLabelProps={{ shrink: true }}
                        variant="outlined"
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={2}>
                    <FormControl fullWidth>
                      <TextField
                        value={this.state.searchCptCode}
                        onChange={this.handleCptCodeChange}
                        label="CPT"
                        name="cptCode"
                        InputLabelProps={{ shrink: true }}
                        variant="outlined"
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={2}>
                    <FormControl fullWidth>
                      <TextField
                        value={this.state.searchInsuranceCompany}
                        onChange={this.handleInsuranceCompanyChange}
                        label="Insurance Co"
                        name="insuranceCompany"
                        InputLabelProps={{ shrink: true }}
                        variant="outlined"
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={4}>
                    <FormControl fullWidth>
                      <TextField
                        value={this.state.searchPrimaryAdjuster}
                        onChange={this.handlePrimaryAdjusterChange}
                        label="Primary Adjuster"
                        name="primaryAdjuster"
                        InputLabelProps={{ shrink: true }}
                        variant="outlined"
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={3}>
                    <FormControl fullWidth>
                      <TextField
                        value={this.state.searchEmployer}
                        onChange={this.handleEmployerChange}
                        label="Employer"
                        name="employer"
                        InputLabelProps={{ shrink: true }}
                        variant="outlined"
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={4}>
                    <FormControl fullWidth variant="outlined">
                      <InputLabel shrink={true} variant="outlined">
                        Quote Type
                      </InputLabel>
                      <Select
                        variant="outlined"
                        input={<OutlinedInput notched label="Quote Type" />}
                        fullWidth
                        id="quoteType"
                        multiple
                        value={Array.from(this.state.searchQuoteType.keys())}
                        renderValue={() =>
                          Array.from(this.state.searchQuoteType.values()).join(', ')
                        }
                        onChange={this.handleQuoteTypeChange}
                        MenuProps={MenuProps}
                      >
                        {this.quoteType.map((item) => (
                          <MenuItem key={item.key} value={item.key} data-name={item.text}>
                            {item.key &&
                            this.state.searchQuoteType.has(item.key.toString()) ? (
                              <CheckBox
                                color="secondary"
                                style={{ paddingRight: '10px' }}
                              />
                            ) : (
                              <CheckBoxOutlineBlank
                                color="action"
                                style={{ paddingRight: '10px' }}
                              />
                            )}{' '}
                            {item.text}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={4}>
                    <FormControl fullWidth variant="outlined">
                      <InputLabel shrink={true} variant="outlined">
                        Quote Status
                      </InputLabel>
                      <Select
                        variant="outlined"
                        input={<OutlinedInput notched label="Quote Status" />}
                        fullWidth
                        id="quoteStatus"
                        multiple
                        value={Array.from(this.state.searchQuoteStatus.keys())}
                        renderValue={() =>
                          Array.from(this.state.searchQuoteStatus.values()).join(', ')
                        }
                        onChange={this.handleQuoteStatusChange}
                        MenuProps={MenuProps}
                      >
                        {this.quoteStatus.map((item) => (
                          <MenuItem key={item.key} value={item.key} data-name={item.text}>
                            {item.key &&
                            this.state.searchQuoteStatus.has(item.key.toString()) ? (
                              <CheckBox
                                color="secondary"
                                style={{ paddingRight: '10px' }}
                              />
                            ) : (
                              <CheckBoxOutlineBlank
                                color="action"
                                style={{ paddingRight: '10px' }}
                              />
                            )}{' '}
                            {item.text}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={2}>
                    <FormControl fullWidth variant="outlined">
                      <InputLabel
                        shrink={true}
                        htmlFor="eoc-status-select"
                        variant="outlined"
                      >
                        EOC Status
                      </InputLabel>
                      <Select
                        variant="outlined"
                        input={
                          <OutlinedInput
                            notched
                            id="eoc-status-select"
                            name="eocStatus"
                            label="EOC Status"
                          />
                        }
                        fullWidth
                        id="eocStatus"
                        value={this.state.searchEOCStatus}
                        onChange={this.handleEOCStatusChange}
                        native
                      >
                        <option value=""></option>
                        {EOCStatusOptions.map((status) => (
                          <option key={status} value={status}>
                            {status}
                          </option>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={2}>
                    <FormControl fullWidth variant="outlined">
                      <InputLabel
                        shrink={true}
                        htmlFor="invoice-status-select"
                        variant="outlined"
                      >
                        Invoice Status
                      </InputLabel>
                      <Select
                        variant="outlined"
                        input={
                          <OutlinedInput
                            notched
                            id="invoice-status-select"
                            name="invoiceStatus"
                            label="Invoice Status"
                          />
                        }
                        fullWidth
                        id="invoiceStatus"
                        value={this.state.searchInvoiceStatus}
                        onChange={this.handleInvoiceStatusChange}
                        native
                      >
                        <option value="">All</option>
                        <option value="Invoiced">Invoiced</option>
                        <option value="NotInvoiced">Not Invoiced</option>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item container direction="row" xs={12} md={6} lg={6}>
                    <FormControl>
                      <FormControlLabel
                        label="Only Consumer Quotes"
                        labelPlacement="end"
                        control={
                          <Checkbox
                            checked={this.state.searchConsumerQuotesOnly}
                            onChange={this.handleConsumerQuotesOnlyChange}
                            inputProps={{
                              id: 'consumer-quotes-only-filter',
                            }}
                            value="searchConsumerQuotesOnly"
                            name="searchConsumerQuotesOnly"
                          />
                        }
                      />
                    </FormControl>
                  </Grid>
                  <Grid
                    container
                    direction="row"
                    spacing={2}
                    style={{
                      width: '100%',
                      marginLeft: '1px',
                      paddingBottom: '10px',
                      paddingTop: '10px',
                    }}
                  >
                    <Grid item>
                      <Button
                        type="submit"
                        color="primary"
                        size="medium"
                        variant="contained"
                      >
                        Search
                      </Button>
                    </Grid>
                    <Grid item>
                      <Button
                        color="secondary"
                        onClick={this.clearSearch}
                        size="medium"
                        variant="contained"
                      >
                        Clear Search
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item container direction="row" style={{ paddingTop: '20px' }}>
                  <Grid item xs={12}>
                    <Typography noWrap variant="h5">
                      Total Invoice Balances Due:&nbsp;
                      <strong>
                        {this.isGridDataEmpty() ? (
                          'N/A'
                        ) : (
                          <CurrencyFormat
                            value={this.state.quoteTotals.totalInvoice}
                            displayType={'text'}
                            thousandSeparator={true}
                            prefix={'$'}
                            fixedDecimalScale={true}
                            decimalScale={2}
                          />
                        )}
                      </strong>
                    </Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography noWrap variant="h5">
                      Total Balance Past Due (30+ days):&nbsp;
                      <strong>
                        {this.isGridDataEmpty() ? (
                          'N/A'
                        ) : (
                          <CurrencyFormat
                            value={this.state.quoteTotals.totalInvoicePastDue}
                            displayType={'text'}
                            thousandSeparator={true}
                            prefix={'$'}
                            fixedDecimalScale={true}
                            decimalScale={2}
                          />
                        )}
                      </strong>
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item style={{ justifyContent: 'flex-end', display: 'flex' }} xs={9}>
                {this.state.hasMMI && (
                  <>
                    <Link
                      style={{
                        marginRight: '20px',
                        cursor: disableLink ? 'default' : 'pointer',
                        color: disableLink ? 'grey' : '#29348F',
                      }}
                      underline={'always'}
                      onClick={
                        disableLink
                          ? () => {}
                          : () => {
                              this.getPdf(true)
                            }
                      }
                    >
                      Bundled Cost Savings Report
                    </Link>
                    <Link
                      style={{
                        cursor: disableLink ? 'default' : 'pointer',
                        color: disableLink ? 'grey' : '#29348F',
                      }}
                      underline={'always'}
                      onClick={
                        disableLink
                          ? () => {}
                          : () => {
                              this.getPdf(false)
                            }
                      }
                    >
                      Non-Bundled Cost Savings Report
                    </Link>
                  </>
                )}
              </Grid>
            </form>
            <Grid item md={12} style={{ width: '100%' }}>
              <Table
                className="gridPaddingDense"
                aria-label="simple table"
                sx={sortedTableHeaderSx}
              >
                <TableHead>
                  <TableRow>
                    <TableCell
                      style={{ paddingLeft: '4px', paddingRight: '4px' }}
                    ></TableCell>
                    {this.renderSortedHeaderIfNotNewlyAdded(
                      'EOC/Legacy',
                      'EocNumber',
                      undefined,
                      { whiteSpace: 'nowrap', paddingLeft: '4px', paddingRight: '4px' }
                    )}
                    {this.renderSortedHeaderIfNotNewlyAdded('#', 'GroupNumber', 'right', {
                      whiteSpace: 'nowrap',
                      paddingLeft: '0px',
                      paddingRight: '4px',
                    })}

                    {this.renderSortedHeaderIfNotNewlyAdded(
                      'Quote Type',
                      'QuoteType',
                      undefined,
                      { whiteSpace: 'nowrap', paddingLeft: '4px', paddingRight: '4px' }
                    )}
                    {this.renderSortedHeaderIfNotNewlyAdded(
                      'Quote Status',
                      'QuoteStatus',
                      undefined,
                      { whiteSpace: 'nowrap', paddingLeft: '4px', paddingRight: '4px' }
                    )}
                    {this.renderSortedHeaderIfNotNewlyAdded(
                      'Patient',
                      'PatientName',
                      undefined,
                      { whiteSpace: 'nowrap', paddingLeft: '4px', paddingRight: '4px' }
                    )}
                    {this.renderSortedHeaderIfNotNewlyAdded(
                      'Insurance Co',
                      'InsuranceCompanyName',
                      undefined,
                      { whiteSpace: 'nowrap', paddingLeft: '4px', paddingRight: '4px' }
                    )}
                    {this.renderSortedHeaderIfNotNewlyAdded(
                      'Start Date',
                      'StartDate',
                      'right',
                      { whiteSpace: 'nowrap', paddingLeft: '4px', paddingRight: '4px' }
                    )}
                    <TableCell style={{ padding: '0' }}>
                      <Tooltip
                        title={`Represents Surgery Date when Surgical or Injection bundle`}
                      >
                        <InfoOutlined
                          fontSize="small"
                          style={{ verticalAlign: 'middle' }}
                        />
                      </Tooltip>
                    </TableCell>
                    {this.renderSortedHeaderIfNotNewlyAdded(
                      '# of Days',
                      'BundleDurationDays',
                      'right',
                      { whiteSpace: 'nowrap', paddingLeft: '4px', paddingRight: '4px' }
                    )}
                    {this.renderSortedHeaderIfNotNewlyAdded('Inbox', 'Inbox', undefined, {
                      whiteSpace: 'nowrap',
                      paddingLeft: '4px',
                      paddingRight: '4px',
                    })}
                    {this.renderSortedHeaderIfNotNewlyAdded(
                      'EOC Status',
                      'EocStatus',
                      undefined,
                      { whiteSpace: 'nowrap', paddingLeft: '4px', paddingRight: '4px' }
                    )}
                    {this.renderSortedHeaderIfNotNewlyAdded(
                      'Quoted $',
                      'Amount',
                      'right',
                      { whiteSpace: 'nowrap', paddingLeft: '4px', paddingRight: '4px' }
                    )}
                    {this.renderSortedHeaderIfNotNewlyAdded(
                      'Reconciled $',
                      'ReconciledAmount',
                      'right',
                      { whiteSpace: 'nowrap', paddingLeft: '4px', paddingRight: '4px' }
                    )}
                    {this.renderSortedHeaderIfNotNewlyAdded(
                      'Claim Recon %',
                      'NonPTOverallClaimPercentageReconciled',
                      'right',
                      { whiteSpace: 'nowrap', paddingLeft: '4px', paddingRight: '4px' }
                    )}
                    <SortedTableCell
                      columnName="Invoiced"
                      propertyName="Invoiced"
                      sortable={false}
                      style={{ paddingLeft: '4px', paddingRight: '4px' }}
                      order={this.state.sortOrder}
                      orderBy={this.state.sortColumn}
                      onClick={this.sort}
                    />
                    <TableCell style={{ paddingLeft: '4px', paddingRight: '4px' }} />
                  </TableRow>
                </TableHead>
                <TableBody>{this.mapGridData()}</TableBody>
              </Table>
              <div className="pagination-row" style={{}}>
                {this.paginationInfo()}
                <ReactPaginate
                  previousLabel={'<'}
                  nextLabel={'>'}
                  onPageChange={this.handlePageChange}
                  forcePage={this.state.page - 1}
                  pageCount={this.state.pageCount}
                  containerClassName={'pagination'}
                  activeClassName={'active'}
                  //@ts-ignore
                  renderOnZeroPageCount={null}
                />
              </div>
            </Grid>
          </Grid>
        </Paper>
      </>
    )
  }
}

const InjectedQuoteList = inject<IStores, IQuoteListProps, Partial<IQuoteListProps>, any>(
  (stores: IStores) => ({
    buildQuoteMenuItems: stores.quotes.buildQuoteMenuItems,
    openBillsDialog: stores.quotes.openBillsDialog,
    invoiceLogModalIsOpen: stores.quotes.invoiceLogModalIsOpen,
    selectedQuoteId: stores.quotes.selectedQuoteId,
    selectedInvoiceId: stores.quotes.selectedInvoiceId,
    openInvoiceLogModal: stores.quotes.openInvoiceLogModal,
    closeInvoiceLogModal: stores.quotes.closeInvoiceLogModal,
    restartQuote: stores.quotes.restartQuote,
    startRecon: stores.quotes.startRecon,
    setParentRefreshWithBundle: stores.quotes.setParentRefreshWithBundle,
    setReloadFunction: stores.quotes.setReloadFunction,
    setQuoteRequest: stores.global.setQuoteRequest,
    storedRequest: stores.global.quoteRequest,
    openQuoteLogModal: stores.quotes.openQuoteLogModal,
    selectedPatientHeader: stores.quotes.selectedQuotePatientHeader,
    headerText: stores.quotes.selectedQuotePatientHeader,
    selectedQuote: stores.quotes.selectedQuote,
    adjusterModalIsOpen: stores.quotes.isAdjusterEmailModalOpen,
  })
)(QuoteList)

export default InjectedQuoteList
export { QuoteList }
